import React, { Component } from 'react';
import { InputField, CardSimples } from 'react-template';

class FormHeader extends Component {
    constructor(props){
        super(props);
        this.setTitulo = this.setTitulo.bind(this);
        this.setDescricao = this.setDescricao.bind(this);
    }

    setTitulo(e, data){
        this.props.changeTitulo(data.value)
        this.props.actions.updateTitulo(data.value);
    }

    setDescricao(e, data){
        this.props.actions.updateDescricao(data.value);
    }

    render() {
        return (
            <CardSimples titulo="Informações" borderBottom form>
                <InputField value={this.props.titulo} 
                        label='Título do formulário'
                        placeholder='' 
                        onChange={this.setTitulo} 
                        required  
                        width={12} phoneWidth={4} tabletWidth={8}
                        name='titulo-do-formulario' 
                        invalidMessage={"Campo Obrigatório"}/>

                <InputField value={this.props.descricao} textarea 
                            label='Descrição'
                            placeholder='' 
                            onChange={this.setDescricao} 
                            required 
                            rows="4" 
                            width={12} phoneWidth={4} tabletWidth={8}
                            name="descricao-do-formulario"
                            invalidMessage={"Campo Obrigatório"} />
            </CardSimples>
        );
    }
}

export default FormHeader;


// WEBPACK FOOTER //
// ./src/components/formbuilder/FormHeader.js